import { render, staticRenderFns } from "./FullContainerSpinner.vue?vue&type=template&id=5dc286a4&scoped=true&"
import script from "./FullContainerSpinner.vue?vue&type=script&lang=js&"
export * from "./FullContainerSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FullContainerSpinner.vue?vue&type=style&index=0&id=5dc286a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc286a4",
  null
  
)

export default component.exports